"use strict";

var angular = require("angular");
var sanitizeMongoKeys = require("../utils/sanitizeMongoKeys");

function populateValuesToAiMap(populateValues) {
  var map = {};
  if (Array.isArray(populateValues)) {
    populateValues.forEach(function (item) {
      if (!item || !item.key) {
        return;
      }
      map[item.key] = {
        defaultValue: item.defaultValue != null ? item.defaultValue : "",
        type: item.type === "number" ? "number" : "text",
        description: item.description != null ? item.description : "",
      };
    });
    return map;
  }
  Object.keys(populateValues || {}).forEach(function (key) {
    var val = populateValues[key];
    if (val && typeof val === "object") {
      map[key] = {
        defaultValue: val.defaultValue != null ? val.defaultValue : "",
        type: val.type === "number" ? "number" : "text",
        description: val.description != null ? val.description : "",
      };
      return;
    }
    map[key] = {
      defaultValue: val != null ? val : "",
      type: "text",
      description: "",
    };
  });
  return map;
}

module.exports = [
  "clients",
  "departments",
  "integration",
  "$state",
  "Integration",
  "Authentication",
  "departmentforms",
  "associatedFormsModal",
  function (
    clients,
    departments,
    integration,
    $state,
    Integration,
    Authentication,
    departmentforms,
    associatedFormsModal
  ) {
    var _this = this;

    this.integration = integration;
    this.userCanUpdate = Authentication.isAuthorized(["admin"]) || (clients ==null);
    this.clients = clients || [];
    this.departments = departments;
    this.departmentforms = departmentforms;
    function verifyParams(paramsObject) {
      for (var key in paramsObject) {
        if (paramsObject[key] === "" || paramsObject[key] === null) {
          return false;
        }
      }
      return true;
    }

    // NO BORRAR
    // ESTA FUNCION SIRVE PARA VER POR QUÉ NO ESTÁ VALIDANDO LA INTEGRACION
    // // Validate integration function
    // this.validateIntegration = function (integration) {
    //     // first we validate that all data is there and correct...
    //     console.log('integration.readOnly:', integration.readOnly);
    //     if (integration.readOnly) return false;

    //     // Global
    //     console.log('!this.userCanUpdate:', !this.userCanUpdate);
    //     console.log('integration.id != undefined:', integration.id != undefined);
    //     console.log('integration.clientId == undefined:', integration.clientId == undefined);
    //     console.log('integration.departmentId == undefined:', integration.departmentId == undefined);

    //     if (
    //         !this.userCanUpdate &&
    //         integration.id != undefined &&
    //         integration.clientId == undefined &&
    //         integration.departmentId == undefined
    //     ) {
    //         console.log('Setting integration as readOnly due to global field validation failure');
    //         _this.integration.readOnly = true;
    //         return false;
    //     }

    //     // DEPT && SITE
    //     console.log('integration.id == undefined:', integration.id == undefined);
    //     if (integration.id == undefined) {
    //         console.log('Setting default clientId and departmentId from departments array');
    //         integration.clientId = departments[0].clientId;
    //         if (departments.length == 1) integration.departmentId = departments[0].id;
    //     }

    //     console.log('integration.departmentId:', integration.departmentId);
    //     console.log('integration.clientId:', integration.clientId);
    //     const deptById = departments.find((dept) => dept.id == integration.departmentId);
    //     const deptByClientId = departments.find((dept) => dept.clientId == integration.clientId);
    //     console.log('Department found by departmentId:', deptById);
    //     console.log('Department found by clientId:', deptByClientId);

    //     if (integration.departmentId && deptById == undefined && integration.clientId && deptByClientId == undefined) {
    //         console.log('Setting integration as readOnly due to department validation failure');
    //         _this.integration.readOnly = true;
    //         return false;
    //     }

    //     console.log('integration.name:', integration.name);
    //     if (!integration.name) {
    //         console.log('Validation failed: integration name is missing');
    //         return false;
    //     }

    //     console.log('integration.type:', integration.type);
    //     if (
    //         integration.type !== "populate" &&
    //         integration.type !== "validate" &&
    //         integration.type !== "getData"
    //     ) {
    //         console.log('Validation failed: invalid integration type');
    //         return false;
    //     }

    //     // Commented out validation
    //     /* console.log('integration.configuration.connection.url:', integration.configuration.connection.url);
    //         if (!integration.configuration.connection.url && integration.id) {
    //         console.log('Validation failed: missing connection URL');
    //         return false;
    //     } */

    //     console.log('integration.configuration.connection.method:', integration.configuration.connection.method);
    //     if (
    //         integration.configuration.connection.method !== "GET" &&
    //         integration.configuration.connection.method !== "POST"
    //     ) {
    //         console.log('Validation failed: invalid connection method');
    //         return false;
    //     }

    //     console.log('integration.configuration.connection.headers:', integration.configuration.connection.headers);
    //     if (!verifyParams(integration.configuration.connection.headers)) {
    //         console.log('Validation failed: invalid connection headers');
    //         return false;
    //     }

    //     console.log('integration.configuration.connection.staticParams:', integration.configuration.connection.staticParams);
    //     if (!verifyParams(integration.configuration.connection.staticParams)) {
    //         console.log('Validation failed: invalid static connection parameters');
    //         return false;
    //     }

    //     console.log('integration.configuration.afterHook:', integration.configuration.afterHook);
    //     if (integration.configuration.afterHook && typeof integration.configuration.afterHook !== "string") {
    //         console.log('Validation failed: afterHook is not a string');
    //         return false;
    //     }

    //     // Now we validate according to type...
    //     if (integration.type === "populate" || integration.type === "validate") {
    //         const dynamicParamsKeys = Object.keys(integration.configuration.connection.dynamicParams);
    //         console.log('integration.configuration.connection.dynamicParams keys:', dynamicParamsKeys);
    //         if (!dynamicParamsKeys.length) {
    //             console.log(`Validation failed: no dynamic parameters for ${integration.type}`);
    //             return false;
    //         }
    //     } else if (integration.type === "getData") {
    //         console.log('Type is getData: no specific validation required');
    //         // No additional validation for getData yet...
    //     }

    //     console.log('Integration is valid');
    //     return true;
    // };
  
    // ESTA FUNCION NO IMPRIME CONSOLE.LOG PORQUE SE LLENARIA LA CONSOLA DE BASURA. 
    //validate integration function
    //might be useful server side...
    this.validateIntegration = function (integration) {
      //first we validate that all data is there and correct...
      if (integration.readOnly) return false;
      //Global
      if (
        !this.userCanUpdate && integration.id!=undefined &&
        integration.clientId == undefined &&
        integration.departmentId == undefined
      ) {
        _this.integration.readOnly = true;
        return false;
      }
      if (
        integration.departmentId &&
        departments.find((dept) => dept.id == integration.departmentId) ==
          undefined &&
        integration.clientId &&
        departments.find((dept) => dept.clientId == integration.clientId) ==
          undefined
      ) {
        _this.integration.readOnly = true;
        return false;
      }

      if (!integration.name) {
        return false;
      }
      if (
        integration.type !== "populate" &&
        integration.type !== "validate" &&
        integration.type !== "getData"
      ) {
        return false;
      }
      /* if (!integration.configuration.connection.url && integration.id) {

            return false;
        } */
      if (
        integration.configuration.connection.method !== "GET" &&
        integration.configuration.connection.method !== "POST"
      ) {
        return false;
      }
    //   if (!verifyParams(integration.configuration.connection.headers)) {
    //     return false;
    //   }
    //   if (!verifyParams(integration.configuration.connection.staticParams)) {
    //     return false;
    //   }
    //   if (
    //     integration.configuration.afterHook &&
    //     typeof integration.configuration.afterHook !== "string"
    //   ) {
    //     return false;
    //   }
    //   //now we validate according to type...
    //   if (integration.type === "populate") {
    //     //if no dynamic params we return false....
    //     if (
    //       !Object.keys(integration.configuration.connection.dynamicParams)
    //         .length
    //     ) {
    //       return false;
    //     }
    //   } else if (integration.type === "validate") {
    //     //if no dynamic params we return false....
    //     if (
    //       !Object.keys(integration.configuration.connection.dynamicParams)
    //         .length
    //     ) {
    //       return false;
    //     }
    //   } else if (integration.type === "getData") {
    //     //nothing yet...
    //   }

      return true;
    };

    this.saveIntegration = function (integration, exportInt) {
      if (!_this.validateIntegration(integration)) {
        return;
      }
      if (integration.configuration.connection.urlType == 'ai') {
        integration.configuration.type = 'json';
        integration.configuration.typeRequest = 'json';
        integration.configuration.connection.allowOffline = false;
        integration.configuration.connection.method = 'POST';
        integration.configuration.connection.url = '{ai-voolks-multimodal}';
        if (!integration.configuration.auth) {
          integration.configuration.auth = {};
        }
        integration.configuration.auth.type = 'AI';
        if (typeof integration.configuration.connection.aiPrompt !== 'string') {
          integration.configuration.connection.aiPrompt = typeof integration.configuration.connection.prompt === 'string'
            ? integration.configuration.connection.prompt
            : '';
        }
        delete integration.configuration.connection.prompt;
        integration.configuration.connection.aiPrompt = integration.configuration.connection.aiPrompt.slice(0, 1024);
        if (integration.configuration.connection.aiModel !== 'lite' && integration.configuration.connection.aiModel !== 'pro') {
          integration.configuration.connection.aiModel = 'lite';
        }
        integration.configuration.populateValues = populateValuesToAiMap(integration.configuration.populateValues);
      } else if ((integration.configuration.connection.url == undefined ||
        integration.configuration.connection.url == "") &&
        integration.configuration.connection.urlType != 'voolks_sheet'
      )
        integration.configuration.connection.allowOffline = true;
      if (!integration.configuration.connection.allowOffline)
        integration.configuration.connection.allowOffline = false;

      // google || voolks sheet populateValues for simple after hook
      if((integration.configuration.connection.urlType === 'voolks_sheet' || integration.configuration.connection.urlType === 'google')
        && integration.configuration.afterHookType === 'simple'){
        integration.configuration.populateValues = {};
        for(const field of integration.configuration.returnData.fields){
          if(field.name && field.name!=""){
            integration.configuration.populateValues[field.name]="";
          }
        }
      }

      const plain = JSON.parse(angular.toJson(integration));
      sanitizeMongoKeys.prepareIntegration(plain);
      integration.configuration = plain.configuration;

      if (!integration.id) {
        //we create a new integration
        return Integration.upsert( integration)
          .$promise.then(function (integration) {
            _this.integration = integration;
          })
          .catch(function (error) {
            console.log(error);
            return;
          });
      }
      
      //we update aleready created integration
      return integration
        .$save()
        .then(function () {
            // console.log('_this.integration', _this.integration);
            if (exportInt) {
                _this.exportJSON();
            }
          return true;
        })
        .catch(function (error) {
          console.log(error);
          return;
        });
    };

    this.exportJSON = () => {
        let file = JSON.parse(JSON.stringify(_this.integration))
        delete file.id;
        delete file.tenantId;
        
        let file2 = JSON.stringify(file, null, 2);

        // console.log('file', file);
        // console.log('file2', file2);

        var blob = new Blob([file2], { type: 'application/json' });
        var url = URL.createObjectURL(blob);

        var a = document.createElement('a');
        a.href = url;
        a.download = file.name.concat('.json');
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    this.openAssociatedForms = () => {
      if (!_this.integration || !_this.integration.id) {
        return;
      }
      associatedFormsModal.open(_this.integration.id, departments);
    };

    this.close = function () {
      $state.reload("dashboard.integrations").then(function () {
        return $state.go("dashboard.integrations");
      });
    };
  },
];
